import {
    ICustomScrollSelector,
    ICustomScrollStore,
} from "./CustomScrollStoreModel";
import { isObjectPropsEquals } from "../_utils/equality";

export function buildListenerOnDiff<T>(
    store: ICustomScrollStore,
    selector: ICustomScrollSelector<T>,
    fn: (s: T) => void
) {
    let value: T;
    const listener = () => {
        const newValue = selector(store.getState());
        if (isObjectPropsEquals(value, newValue)) return;

        value = newValue;
        fn(value);
    };
    listener();
    return store.subscribe(listener);
}
